/**
 * Available Icons.
 *
 * This file is auto-generated.
 */
export enum IconName {
  APPLE = 'i-apple',
  ARROW_DOWN = 'i-arrow_down',
  ARROW_UP = 'i-arrow_up',
  BENCHAMRKING_REVENUE_TOP_FIVE_CUSTOMERS = 'i-benchamrking-revenue-top-five-customers',
  BENCHMARKING_AVERAGE_CUSTOMER_REVENUE = 'i-benchmarking-average-customer-revenue',
  BENCHMARKING_FEEDBACK = 'i-benchmarking-feedback',
  BENCHMARKING_NUMBER_PAYING_CUSTOMERS = 'i-benchmarking-number-paying-customers',
  BENCHMARKING_RECURRING_REVENUE_GROWTH = 'i-benchmarking-recurring-revenue-growth',
  BENCHMARKING_RECURRING_REVENUE_PERCENTAGE = 'i-benchmarking-recurring-revenue-percentage',
  BENCHMARKING_TITLE = 'i-benchmarking-title',
  BENCHMARKING_YEARLY_REVENUE = 'i-benchmarking-yearly-revenue',
  CONNECTWISE = 'i-connectwise',
  DOT = 'i-dot',
  GOOGLE = 'i-google',
  INFO = 'i-info',
  LOADER = 'i-loader',
  LOGO_BEECASTLE_FULL = 'i-logo-beecastle-full',
  LOGO_BEECASTLE = 'i-logo-beecastle',
  LOGO_OFFICE_365 = 'i-logo-office-365',
  LOGO_OUTLOOK = 'i-logo-outlook',
  LOGO_TEAMS = 'i-logo-teams',
  LOGO_WORKMAIL = 'i-logo-workmail',
  MICROSOFT_SIGNIN_DARK = 'i-microsoft-signin-dark',
  MICROSOFT_SIGNUP_DARK = 'i-microsoft-signup-dark',
  MICROSOFT_TEAMS = 'i-microsoft-teams',
  MICROSOFT = 'i-microsoft',
  OUTLOOKCOM = 'i-outlookcom',
  ADD = 'i-s-add',
  ALARM_BELL = 'i-s-alarm-bell',
  AMAZON_WEB_SERVICE_ANALYTIC = 'i-s-amazon-web-service-analytic',
  ANALYTICS_BARS_CIRCLE = 'i-s-analytics-bars-circle',
  ANALYTICS_BARS = 'i-s-analytics-bars',
  ANALYTICS_GRAPH_BAR_1 = 'i-s-analytics-graph-bar-1',
  ANALYTICS_GRAPH_BAR = 'i-s-analytics-graph-bar',
  ANALYTICS_GRAPH = 'i-s-analytics-graph',
  ANALYTICS_PIE_2 = 'i-s-analytics-pie-2',
  ANGLE_BRACKETS_5 = 'i-s-angle-brackets-5',
  ARROW_BUTTON_DOWN_1_1 = 'i-s-arrow-button-down-1-1',
  ARROW_BUTTON_UP_1_2 = 'i-s-arrow-button-up-1-2',
  ARROW_DOWN_1_3 = 'i-s-arrow-down-1-3',
  ARROW_RIGHT_1 = 'i-s-arrow-right-1',
  ARROW_UP_1 = 'i-s-arrow-up-1',
  AWARD_RIBBON_STAR = 'i-s-award-ribbon-star',
  AWARD_TROPHY_STAR = 'i-s-award-trophy-star',
  BIN = 'i-s-bin',
  BUILDING_1 = 'i-s-building-1',
  BUTTON_REFRESH_ARROW = 'i-s-button-refresh-arrow',
  BUTTON_REFRESH_ARROWS = 'i-s-button-refresh-arrows',
  CALENDAR = 'i-s-calendar',
  CASH_SEARCH = 'i-s-cash-search',
  CHECK_1 = 'i-s-check-1',
  CHECK_CIRCLE = 'i-s-check-circle',
  CLOSE = 'i-s-close',
  CLOUD_SYNC = 'i-s-cloud-sync',
  COG = 'i-s-cog',
  COMMON_FILE_TEXT = 'i-s-common-file-text',
  CONTROLS_PAUSE = 'i-s-controls-pause',
  CREDIT_CARD_1 = 'i-s-credit-card-1',
  CUSTOMER_RELATIONSHIP_MANAGEMENT_TRACKING_CONVERSATION = 'i-s-customer-relationship-management-tracking-conversation',
  DATA_FILE_BARS = 'i-s-data-file-bars',
  DELETE_1 = 'i-s-delete-1',
  DIAMOND_SHINE = 'i-s-diamond-shine',
  DOWNLOAD_BOTTOM = 'i-s-download-bottom',
  EMAIL_ACTION_CHECK = 'i-s-email-action-check',
  EMAIL_ACTION_REMOVE = 'i-s-email-action-remove',
  EMAIL_ACTION_SEND_2 = 'i-s-email-action-send-2',
  EMAIL_ACTION_UNREAD = 'i-s-email-action-unread',
  EXPAND_3 = 'i-s-expand-3',
  FILTER_3 = 'i-s-filter-3',
  FOLDER_EMPTY_1 = 'i-s-folder-empty-1',
  GAUGE_DASHBOARD = 'i-s-gauge-dashboard',
  HOUSE_1 = 'i-s-house-1',
  IMAGE_FILE_LANDSCAPE = 'i-s-image-file-landscape',
  LAYERS_GRID_ADD = 'i-s-layers-grid-add',
  LAYERS_GRID_REMOVE = 'i-s-layers-grid-remove',
  LAYERS_HIDE = 'i-s-layers-hide',
  LAYOUT_MODULE = 'i-s-layout-module',
  LEGAL_CERTIFICATE = 'i-s-legal-certificate',
  MEASURE_RULER = 'i-s-measure-ruler',
  MESSAGES_BUBBLE_TYPING_1 = 'i-s-messages-bubble-typing-1',
  MULTIPLE_ACTIONS_VIEW = 'i-s-multiple-actions-view',
  MULTIPLE_NEUTRAL_1 = 'i-s-multiple-neutral-1',
  MULTIPLE_NEUTRAL_2 = 'i-s-multiple-neutral-2',
  NAVIGATION_MENU_HORIZONTAL = 'i-s-navigation-menu-horizontal',
  NOTES_BOOK = 'i-s-notes-book',
  PENCIL_WRITE = 'i-s-pencil-write',
  PENCIL = 'i-s-pencil',
  PHONE_ACTIONS_CLOCK = 'i-s-phone-actions-clock',
  PHONE_FILL = 'i-s-phone-fill',
  PHONE = 'i-s-phone',
  PIN_2 = 'i-s-pin-2',
  PIN = 'i-s-pin',
  QUESTION_CIRCLE = 'i-s-question-circle',
  RANKING_FIRST = 'i-s-ranking-first',
  RATING_STAR_CIRCLE = 'i-s-rating-star-circle',
  REORDER_UP = 'i-s-reorder-up',
  SEARCH = 'i-search',
  SECURITY_LOCK = 'i-s-security-lock',
  SELECT_DRAG_REORDER_DOTS = 'i-s-select-drag-reorder-dots',
  SHARE_EXTERNAL_LINK_1 = 'i-s-share-external-link-1',
  SHRINK_2 = 'i-s-shrink-2',
  SINGLE_NEUTRAL_ACTIONS_ADD = 'i-s-single-neutral-actions-add',
  SINGLE_NEUTRAL_ACTIONS_SETTING = 'i-s-single-neutral-actions-setting',
  SINGLE_NEUTRAL_CIRCLE = 'i-s-single-neutral-circle',
  SINGLE_NEUTRAL = 'i-s-single-neutral',
  TAGS = 'i-s-tags',
  TASK_LIST_CHECK = 'i-s-task-list-check',
  TASK_LIST_MULTIPLE = 'i-s-task-list-multiple',
  TIME_CLOCK_CIRCLE = 'i-s-time-clock-circle',
  TOOLS_PICKAXE = 'i-s-tools-pickaxe',
  UNDO = 'i-s-undo',
  VIDEO_FILE_PLAY = 'i-s-video-file-play',
  VIEW_1 = 'i-s-view-1',
  WORKFLOW_DATA_TABLE_INCREASING_ARROW = 'i-s-workflow-data-table-increasing-arrow',
  ZOOM_IN = 'i-s-zoom-in',
  ZOOM_OUT = 'i-s-zoom-out',
  TRIANGLE_DOWN = 'i-triangle-down',
  XERO_CONNECT_BLUE = 'i-xero-connect-blue',
}
